module.exports = __webpack_public_path__ + "img/add_photo.d0fbc5a1.png";